// extracted by mini-css-extract-plugin
export var icon = "Icons-module--icon--370a4";